var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusAccordion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.249999C6.19811 0.25259 6.38737 0.332439 6.52747 0.472534C6.66756 0.612628 6.74741 0.801893 6.75 1L6.75 5.25L11 5.25C11.1989 5.25 11.3897 5.32901 11.5303 5.46967C11.671 5.61032 11.75 5.80109 11.75 6C11.75 6.19891 11.671 6.38968 11.5303 6.53033C11.3897 6.67099 11.1989 6.75 11 6.75L6.75 6.75L6.75 11C6.75 11.1989 6.67099 11.3897 6.53033 11.5303C6.38968 11.671 6.19891 11.75 6 11.75C5.80109 11.75 5.61032 11.671 5.46967 11.5303C5.32901 11.3897 5.25 11.1989 5.25 11L5.25 6.75L1 6.75C0.801088 6.75 0.610319 6.67099 0.469666 6.53033C0.329013 6.38968 0.25 6.19891 0.250001 6C0.250001 5.80109 0.329013 5.61032 0.469666 5.46966C0.610319 5.32901 0.801088 5.25 1 5.25L5.25 5.25L5.25 0.999999C5.25259 0.801893 5.33244 0.612628 5.47254 0.472534C5.61263 0.332439 5.80189 0.25259 6 0.249999Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAccordion);
export default __webpack_public_path__ + "static/media/plus-accordion.14af0525c5592c0ea0ac770e6c80b6e0.svg";
export { ForwardRef as ReactComponent };